module.exports = __webpack_public_path__ + "img/1554492988.26def537.jpg";